import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
    withStyles,
    List,
    Button,
    ListItem,
    ListItemText,
    Typography,
    CircularProgress,
    ListItemAvatar,
    Avatar,
    Checkbox,
    Collapse,
    FormControlLabel,
    Fab,
    Tooltip,
    ListItemSecondaryAction,
    IconButton
} from '@material-ui/core';
import { ExpandLess, ExpandMore, Add as AddIcon, Close as CloseIcon, HowToReg } from '@material-ui/icons';
import { FHETextField, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { getUsersRights, editUser, addUser } from './actions';

let firstUserIndex = 0;

class Menu extends Component {
    static propTypes = {
        getUsersRights: PropTypes.func.isRequired,
        editUser: PropTypes.func.isRequired,
        addUser: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            users: {},
            userForm: {},
            allRights: {},
            addingUser: false,
            textInput_error: {},
            edited: false
        };
        this.saveUserForm = this.saveUserForm.bind(this);
        this.quitUserForm = this.quitUserForm.bind(this);
        this.addUserForm = this.addUserForm.bind(this);
        this.saveNewUserForm = this.saveNewUserForm.bind(this);
    }

    componentDidMount() {
        const { getUsersRights, history, profile } = this.props;
        if (!profile.get('admin')) return history.replace('/error/403');
        getUsersRights().then(data => {
            const keysSorted = Object.keys(data.users).sort((a, b) => {
                return data.users[a].firstname.localeCompare(data.users[b].firstname);
            });
            firstUserIndex = keysSorted[0];
            this.setState({
                loading: false,
                users: data.users,
                userForm: data.users[firstUserIndex],
                allRights: data.allRights,
                listCollapsed: [],
                buttonLoading: false
            });
        });
    }

    setUserForm(user) {
        this.setState({ userForm: user, addingUser: false, textInput_error: {} });
    }
    isFormValid = () => {
        const { userForm } = this.state;
        const errors = {};

        if (this.isEmpty(userForm.email)) errors['email'] = Translator.translate('general.fields.error.any.empty');
        else if (!/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(userForm.email))
            errors['email'] = Translator.translate('general.fields.error.string.regex.base');

        if (this.isEmpty(userForm.firstname)) errors['firstname'] = Translator.translate('general.fields.error.any.empty');

        if (this.isEmpty(userForm.lastname)) errors['lastname'] = Translator.translate('general.fields.error.any.empty');

        this.setState({ textInput_error: errors });

        return Object.keys(errors).length <= 0;
    };
    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };
    handleToggle = name => () => {
        const { userForm } = this.state;
        this.setState({ userForm: { ...userForm, [name]: !userForm[name] } });
    };
    handleChange = name => event => {
        const { userForm } = this.state;
        this.setState({ userForm: { ...userForm, [name]: event.target.value }, textInput_error: {}, edited: true });
    };
    setRight = (rightType, env, rights) => event => {
        let { userForm } = this.state;
        if (!userForm.user_rights[env]) userForm.user_rights[env] = [];

        let User = JSON.parse(JSON.stringify(userForm));
        let userRights = User.user_rights[env];
        switch (rightType) {
            case 'env':
                userRights.splice(0, userRights.length);
                if (event.target.checked)
                    Object.keys(rights).map(product => {
                        Array.prototype.push.apply(userRights, rights[product]);
                    });
                break;
            case 'product':
                rights.forEach(right => {
                    let indexRight = userRights.indexOf(right);
                    if (event.target.checked && indexRight === -1) userRights.push(right);
                    else if (!event.target.checked && indexRight !== -1) userRights.splice(indexRight, 1);
                });

                break;
            case 'right':
                if (event.target.checked) userRights.push(rights);
                else {
                    userRights.splice(userRights.indexOf(rights), 1);
                }
                break;
        }

        return this.setState({ userForm: User, edited: true });
    };
    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });
        this.setState({
            buttonLoading: false,
            textInput_error: res
        });

        return Toastr.error(message);
    };
    quitUserForm() {
        const { history } = this.props;
        const { edited } = this.state;
        if (edited) {
            Toastr.confirm(
                Translator.translate('general.rights.quitConfirmationText'),
                Translator.translate('general.rights.quitConfirmationTitle'),
                {
                    onYes: () => {
                        return history.push('/menu');
                    }
                }
            );
        } else {
            return history.push('/menu');
        }
    }
    saveUserForm() {
        const { editUser } = this.props;
        const { userForm, users } = this.state;
        if (!this.isFormValid()) return false;
        this.setState({ buttonLoading: true, edited: false });
        editUser(userForm)
            .then(user => {
                Toastr.success(Translator.translate('general.usersRights.action.editUser.success', user.lastname, user.firstname));
                this.setState({ users: { ...users, [user._id]: user }, userForm: user, buttonLoading: false });
            })
            .catch(error => {
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(
                        error.validation.errors,
                        Translator.translate('general.usersRights.action.editUser.error', userForm.lastname, userForm.firstname)
                    );
                }
                Toastr.error(Translator.translate('general.usersRights.action.editUser.error', userForm.lastname, userForm.firstname));
                this.setState({ buttonLoading: false });
            });
    }

    saveNewUserForm() {
        const { addUser } = this.props;
        const { userForm, users } = this.state;

        // if (!this.isFormValid()) return false;
        this.setState({ buttonLoading: true });

        addUser(userForm)
            .then(user => {
                Toastr.success(Translator.translate('general.usersRights.action.addUser.success', user.lastname, user.firstname));
                return this.setState({ users: { ...users, [user._id]: user }, userForm: user, addingUser: false, buttonLoading: false });
            })
            .catch(error => {
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(
                        error.validation.errors,
                        Translator.translate('general.usersRights.action.addUser.error', userForm.lastname, userForm.firstname)
                    );
                }
                Toastr.error(Translator.translate('general.usersRights.action.addUser.error', userForm.lastname, userForm.firstname));
                this.setState({ buttonLoading: false });
            });
    }
    addUserForm() {
        const userForm = {
            email: '',
            lastname: '',
            firstname: '',
            active: true,
            user_rights: {}
        };
        this.setState({ addingUser: true, userForm });
    }

    handleClickExpand(listId = null) {
        let { listCollapsed } = this.state;
        let indexOfListId = listCollapsed.indexOf(listId);
        if (indexOfListId !== -1) listCollapsed.splice(indexOfListId, 1);
        else listCollapsed.push(listId);
        return this.setState({ listCollapsed });
    }

    renderUserList() {
        const { users, userForm } = this.state;
        const { classes } = this.props;
        let userItems = [];
        const keysSorted = Object.keys(users).sort((a, b) => {
            return users[a].firstname.localeCompare(users[b].firstname);
        });
        firstUserIndex = keysSorted[0];
        keysSorted.forEach(userId => {
            const user = users[userId];
            userItems.push(
                <ListItem
                    key={userId}
                    button
                    onClick={this.setUserForm.bind(this, user)}
                    selected={user._id === userForm._id}
                    className={classes.listUser}
                >
                    <ListItemAvatar>
                        <Avatar>{user.lastname.charAt(0)}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        primary={`${user.firstname} ${user.lastname}`}
                        secondary={!user.active ? Translator.translate('general.usersRights.disabledUser') : null}
                    />
                </ListItem>
            );
        });
        return userItems;
    }
    renderUserRights() {
        const { userForm, allRights, listCollapsed } = this.state;
        const { classes } = this.props;

        let rightList = [];

        Object.keys(allRights).map(env => {
            let rightsEnv = allRights[env];
            let envRightsList = [];
            let allRightsEnvchecked = true;
            Object.keys(rightsEnv).map(product => {
                let rightsProduct = rightsEnv[product];
                let productRightsList = [];
                let allRightsProductchecked = true;
                rightsProduct.forEach(right => {
                    let checked =
                        Array.isArray(right) || (userForm.user_rights && userForm.user_rights[env] && userForm.user_rights[env].indexOf(right) !== -1)
                            ? true
                            : false;
                    allRightsProductchecked = allRightsProductchecked && checked;
                    if (!Array.isArray(right)) {
                        productRightsList.push(
                            <ListItem key={right} dense className={classes.denseListItem}>
                                <Checkbox
                                    onChange={this.setRight('right', env, right)}
                                    checked={checked}
                                    tabIndex={-1}
                                    disableRipple
                                    className={classes.denseCheckbox}
                                />
                                <ListItemText primary={Translator.translate(`general.rights.${right}`)} />
                            </ListItem>
                        );
                    }
                });
                allRightsEnvchecked = allRightsEnvchecked && allRightsProductchecked;

                envRightsList.push(
                    <div key={product}>
                        <ListItem dense className={classes.denseListItem}>
                            <Checkbox
                                checked={allRightsProductchecked}
                                tabIndex={-1}
                                disableRipple
                                className={classes.denseCheckbox}
                                onChange={this.setRight('product', env, rightsProduct)}
                            />
                            <ListItemText primary={Translator.translate(`general.${product}`)} />
                            <ListItemSecondaryAction hidden={product === `init`}>
                                <IconButton onClick={this.handleClickExpand.bind(this, `${env}_${product}`)} className={classes.buttonCollapse}>
                                    {listCollapsed.indexOf(`${env}_${product}`) !== -1 ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Collapse in={listCollapsed.indexOf(`${env}_${product}`) !== -1} timeout="auto" unmountOnExit>
                            <List component="div" className={classes.subListProduct} hidden={product === `init`}>
                                {productRightsList}
                            </List>
                        </Collapse>
                    </div>
                );
            });
            rightList.push(
                <div key={env}>
                    <ListItem dense className={classes.denseListItem}>
                        <Checkbox
                            checked={allRightsEnvchecked}
                            tabIndex={-1}
                            disableRipple
                            onChange={this.setRight('env', env, rightsEnv)}
                            className={classes.denseCheckbox}
                        />
                        <ListItemText primary={Translator.translate(`${env}.menuItem`).toUpperCase()} />
                        <ListItemSecondaryAction>
                            <IconButton onClick={this.handleClickExpand.bind(this, env)} className={classes.buttonCollapse}>
                                {listCollapsed.indexOf(env) !== -1 ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Collapse in={listCollapsed.indexOf(env) !== -1} timeout="auto" unmountOnExit>
                        <List component="div" className={classes.subListEnv}>
                            {envRightsList}
                        </List>
                    </Collapse>
                </div>
            );
        });

        return (
            <List component="nav" disablePadding dense>
                {rightList}
            </List>
        );
    }
    renderUserForm() {
        const { userForm, addingUser, textInput_error, users } = this.state;
        const { theme, classes } = this.props;
        return (
            <form noValidate autoComplete="off">
                <div className={classes.userFieldsFormContainer}>
                    <div className={classes.containerTitleForm}>
                        <Typography className={classes.subTitle} variant="h6">
                            {addingUser
                                ? Translator.translate('general.usersRights.userForm.titleAdd')
                                : Translator.translate('general.usersRights.userForm.title')}
                        </Typography>
                        {addingUser ? (
                            <Tooltip title={Translator.translate('general.cancel')} placement="top">
                                <Fab
                                    color="primary"
                                    className={classes.addIcon}
                                    size="small"
                                    onClick={this.setUserForm.bind(this, users[firstUserIndex])}
                                    style={{ backgroundColor: theme.palette.common.white }}
                                >
                                    <CloseIcon style={{ color: theme.palette.error.main }} />
                                </Fab>
                            </Tooltip>
                        ) : (
                            <Tooltip title={Translator.translate('general.addUser')} placement="top">
                                <Fab color="primary" className={classes.addIcon} size="small" onClick={this.addUserForm}>
                                    <AddIcon />
                                </Fab>
                            </Tooltip>
                        )}
                    </div>
                    <div className="row userRightList">
                        <div className="col-md-6">
                            <FHETextField
                                id="lastname"
                                label={Translator.translate('general.fields.lastname')}
                                error={textInput_error.lastname}
                                fullWidth
                                value={userForm.lastname ? userForm.lastname : ''}
                                onChange={this.handleChange('lastname')}
                                margin="normal"
                            />
                        </div>
                        <div className="col-md-6">
                            <FHETextField
                                id="firstname"
                                label={Translator.translate('general.fields.firstname')}
                                error={textInput_error.firstname}
                                fullWidth
                                value={userForm.firstname ? userForm.firstname : ''}
                                onChange={this.handleChange('firstname')}
                                margin="normal"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <FHETextField
                                id="email"
                                label={Translator.translate('general.fields.email')}
                                error={textInput_error.email}
                                fullWidth
                                value={userForm.email ? userForm.email : ''}
                                onChange={this.handleChange('email')}
                                margin="normal"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <FormControlLabel
                                control={<Checkbox checked={userForm.active} onChange={this.handleToggle('active')} value="active" />}
                                label={Translator.translate('general.fields.userActive')}
                            />
                        </div>
                    </div>
                </div>

                <Typography className={classes.subTitle} variant="h6">
                    {Translator.translate('general.usersRights.userRightForm.title')}
                </Typography>
                <div className={`${classes.listContainer} row`}>
                    <div className={`${classes.userRightFormContainer} col-md-12`}>{this.renderUserRights()}</div>
                </div>
            </form>
        );
    }

    render() {
        const { theme, classes } = this.props;
        const { loading, addingUser, buttonLoading, edited } = this.state;
        if (loading) {
            return (
                <div className="pageDetailContainer">
                    <div className="loadingContainer">
                        <CircularProgress />
                    </div>
                </div>
            );
        }
        return (
            <div className={classes.generalContainer}>
                <div className={classes.pageUsersRightsContainer} style={{ backgroundColor: theme.palette.background.paper }}>
                    <span className={classes.title}>
                        <FHETitle title={Translator.translate('general.usersRights.title')} MuiIcon={HowToReg} />
                    </span>
                    <div className="row">
                        <div className={`${classes.userListContainer} col-xl-3 col-md-4 col-xs-12`}>{this.renderUserList()} </div>
                        <div className="col-xl-9 col-md-8 col-xs-12 userFormContainer">{this.renderUserForm()}</div>
                    </div>
                    <div className={`${classes.userRightfooter} row`}>
                        <Button
                            style={{ backgroundColor: theme.palette.background.paper, color: theme.palette.error.main }}
                            disabled={buttonLoading}
                            variant="contained"
                            className={classes.button}
                            onClick={this.quitUserForm}
                        >
                            {Translator.translate('general.button.exit')}
                        </Button>
                        {addingUser ? (
                            <Button
                                disabled={buttonLoading}
                                variant="contained"
                                className={classes.button}
                                color="primary"
                                onClick={this.saveNewUserForm}
                            >
                                {buttonLoading && <CircularProgress size={20} className={classes.loaderButton} />}
                                {Translator.translate('general.button.add')}
                            </Button>
                        ) : (
                            <Button
                                disabled={buttonLoading || !edited}
                                variant="contained"
                                className={classes.button}
                                color="primary"
                                onClick={this.saveUserForm}
                            >
                                {buttonLoading && <CircularProgress size={20} className={classes.loaderButton} />}
                                {Translator.translate('general.button.save')}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

const styles = theme => ({
    button: {
        margin: theme.spacing(1)
    },
    loaderButton: {
        marginRight: theme.spacing(1)
    },
    generalContainer: {
        height: '100vh',
        width: '100vw',
        overflowY: 'auto',
        padding: 60,
        zIndex: 2,
        [theme.breakpoints.down('md')]: {
            padding: 15
        }
    },
    pageUsersRightsContainer: {
        borderRadius: 8,
        padding: 50,
        [theme.breakpoints.down('sm')]: {
            padding: 10
        }
    },
    title: {
        width: '100%',
        position: 'relative',
        top: 10,
        left: 10,
        [theme.breakpoints.down('sm')]: {
            top: 3,
            left: 3
        }
    },
    subTitle: {
        width: '100%'
    },
    userListContainer: {
        overflow: 'auto',
        maxHeight: '60vh',
        minHeight: 'calc(292px + 200px)',
        [theme.breakpoints.down('sm')]: {
            width: '95%'
        }
    },
    userRightFormContainer: {
        marginTop: 20,
        overflow: 'auto',
        maxHeight: 'calc(60vh - 292px)',
        minHeight: 200,
        [theme.breakpoints.down('sm')]: {
            minHeight: '100%',
            maxHeight: '100%',
            maxWidth: '100%',
            marginTop: 20
        }
    },
    denseListItem: {
        paddingLeft: 0,
        paddingTop: 2,
        paddingBottom: 2
    },
    denseCheckbox: {
        paddingLeft: 0,
        paddingTop: 2,
        paddingBottom: 2
    },
    subListEnv: {
        paddingLeft: 20
    },
    subListProduct: {
        paddingLeft: 20
    },
    buttonCollapse: {
        padding: 2
    },
    userRightfooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid grey',
        paddingTop: 15,
        marginTop: 30,
        [theme.breakpoints.down('sm')]: {
            marginRight: 10,
            marginLeft: 10
        }
    },
    listUser: {
        borderRadius: 8
    },
    listContainer: {
        width: '100%',
        marginRight: -15,
        marginLeft: 0,
        [theme.breakpoints.down('sm')]: {
            maxHeight: 300,
            minHeight: 200,
            overflowY: 'scroll',
            marginRight: -15,
            marginLeft: 0
        }
    },
    addIcon: {
        minWidth: 40
    },
    containerTitleForm: {
        display: 'flex',
        alignItems: 'center'
    },
    userFieldsFormContainer: {
        [theme.breakpoints.down('md')]: {
            marginTop: 20
        }
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getUsersRights, editUser, addUser }, dispatch)
    )(withStyles(styles, { withTheme: true })(Menu))
);



// WEBPACK FOOTER //
// ./scenes/UsersRights/index.js